import { ApiError } from './ApiError';
import { UnknownError } from './UnknownError';

export function normalizeApiError(err: unknown): ApiError | UnknownError {
  return err instanceof ApiError ? err : new UnknownError(err);
}
